import { useEffect, useRef } from 'react'
import { atom, useRecoilState } from 'recoil'
import { ISIP } from './use-sips'

interface IFilters {
  verbatim: string
  statuses: string[]
  preferences: string[]
  type: string
}

const filtersState = atom<IFilters>({
  key: 'VoipSIPsFilters',
  default: {
    verbatim: '',
    statuses: [],
    preferences: [],
    type: 'room'
  }
})

const selectionState = atom<ISIP[]>({
  key: 'VoipSIPsSelection',
  default: []
})

const sortState = atom({
  key: 'VoipSIPsSort',
  default: {
    by: 'status',
    direction: 'desc'
  }
})

type SortOutput = [{ direction: string; by: string }, (sort: string) => void]

export const useSort = (): SortOutput => {
  const [{ direction, by }, setSort] = useRecoilState(sortState)
  return [
    { direction, by },
    sort => {
      if (by === sort) {
        const newDirection = direction === 'asc' ? 'desc' : 'asc'
        setSort({ by: sort, direction: newDirection })
      } else {
        setSort({ by: sort, direction: 'asc' })
      }
    }
  ]
}

export const useSelection = () => {
  return useRecoilState(selectionState)
}

export const useFilters = (initialValues?: Partial<IFilters>) => {
  const [filters, setFilters] = useRecoilState(filtersState)
  const initialized = useRef(false)

  useEffect(() => {
    if (!initialValues || initialized.current) return
    initialized.current = true
    setFilters(prev => ({ ...prev, ...initialValues }))
  }, [])

  return [filters, setFilters] as const
}
